import RequiresAuth from '@website/components/auth/RequiresAuth';
import HostNotifications from '@website/components/notifications/HostNotifications';
import SeoMetaTags from '@website/components/seoMetaTags';
import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';

export default function Notifications() {
  const { query } = useRouter();
  const hostURL = query.hostURL as string;

  return (
    <>
      <SeoMetaTags
        title="Notifications"
        description="A list of notifications for the host"
      />
      <RequiresAuth>
        <Container className="pt-3">
          <HostNotifications urlSlug={hostURL} />
        </Container>
      </RequiresAuth>
    </>
  );
}
